import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserGroup, UserGroupIcons } from "../../../app/app.interfaces";
import { ApiService } from "../../../services/api.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FormHelper } from "../../../helpers/form.helper";
import { IonicHelper } from "../../../helpers/ionic.helper";
import { UserGroupService } from "../../../services/user-group.service";

@Component({
	selector: 'admin-user-group',
	templateUrl: 'admin-user-group.html'
})


export class AdminUserGroup implements OnInit {

	@Input() userGroup: UserGroup;
	@Output() userGroupChange: EventEmitter<UserGroup> = new EventEmitter<UserGroup>();
	@Output() userGroupRemove: EventEmitter<UserGroup> = new EventEmitter<UserGroup>();
	userGroupIcons: string[] = UserGroupIcons;
	
	form: FormGroup;
	edit: boolean = false;

	constructor( private apiService: ApiService,
							 private ionic: IonicHelper,
							 private formBuilder: FormBuilder,
							 private userGroupService: UserGroupService){
	}

	toggleEdit(show){
		if(show===undefined) this.edit = !this.edit;
		else this.edit=show;
	}

	ngOnInit(): void {

		this.buildForm();

	}

	buildForm(): void{

		this.form = this.formBuilder.group({
			name: [this.userGroup.name, Validators.compose([Validators.minLength(3), Validators.maxLength(100)])],
			abbreviation: [this.userGroup.abbreviation, Validators.compose([Validators.minLength(2), Validators.maxLength(100)])],
			description: [this.userGroup.description, Validators.compose([Validators.minLength(10), Validators.maxLength(400)])],
			icon: [this.userGroup.icon, Validators.compose([Validators.required])]
		});

	}

	submitForm(): void {

		this.ionic.toggleLoader(true);

		if(this.form.valid){

			let updatedUserGroup = FormHelper.updateObjectWithFormValues(this.userGroup, this.form);

			this.apiService.updateResource(updatedUserGroup).then((userGroup) => {

				this.userGroup = userGroup;
				// this.form.reset();
				this.ionic.toggleLoader(false);
				this.ionic.toast('ADMIN.GROUPS.UPDATED_TOAST');
				this.edit = false;

			}).catch((err) => {
				console.error(err);
				this.ionic.toggleLoader(false);
				this.ionic.alert('GLOBAL.GENERAL_ERROR');
			});
		}
		else {
			this.ionic.toggleLoader(false);
			this.ionic.invalidFieldsAlert(
				'ADMIN.GROUPS.ERROR',
				'POST_CREATE.TRY_AGAIN',
				'ADMIN.GROUPS.ERRORS',
				FormHelper.getInvalidFormControls(this.form.controls)
			);
		}

	}


	deleteUserGroup(){
		this.ionic.confirm('ADMIN.GROUPS.CONFIRM_DELETE_MSG', 'GLOBAL.ARE_YOU_SURE','GLOBAL.DELETE').subscribe((confirmed: boolean) => {
			if(confirmed){
				this.apiService.deleteResource(this.userGroup).then(()=>{
					
				  this.userGroupRemove.emit(this.userGroup);
				  this.ionic.toast('ADMIN.GROUPS.DELETED_TOAST');
					
				}).catch((err) => {
					console.error(err);    	
					this.ionic.alert('GLOBAL.GENERAL_ERROR');
				});
      
			}
		});

	}

}



// WEBPACK FOOTER //
// ./src/partials/admin/admin-user-group/admin-user-group.ts